/**
 * MobileNav — bottom tab bar shown on mobile (<768px) when the sidebar is hidden.
 * Shows 5 primary navigation items + a "More" sheet for everything else.
 */
import React, { useState } from 'react';
import './MobileNav.css';

const PRIMARY_TABS = [
  { id: 'client-workspace', icon: '🏠', label: 'Home', adminId: 'ops-console' },
  { id: 'unified-inbox',    icon: '📥', label: 'Inbox' },
  { id: 'crm',             icon: '👥', label: 'CRM' },
  { id: 'bookings',        icon: '📅', label: 'Bookings' },
  { id: '__more__',        icon: '⋯',  label: 'More' },
];

const MORE_ITEMS = [
  { id: 'whatsapp',          icon: '💬', label: 'WhatsApp' },
  { id: 'campaigns',         icon: '📢', label: 'Campaigns' },
  { id: 'sales-dashboard',   icon: '📈', label: 'Sales' },
  { id: 'payments',          icon: '💳', label: 'Payments' },
  { id: 'analytics-dashboard', icon: '📊', label: 'Analytics' },
  { id: 'support',           icon: '🎧', label: 'Support' },
  { id: 'knowledge-base',    icon: '📚', label: 'Knowledge' },
  { id: 'recordings',        icon: '🎧', label: 'Recordings' },
  { id: 'social-channels',   icon: '🌐', label: 'Channels' },
  { id: 'settings',          icon: '⚙️', label: 'Settings' },
  { id: 'billing',           icon: '📋', label: 'Billing' },
  { id: 'business-context',  icon: '🏢', label: 'Profile' },
];

const MORE_ADMIN = [
  { id: 'clients-mgmt',   icon: '🏢', label: 'Clients' },
  { id: 'team-manager',   icon: '👥', label: 'Team' },
  { id: 'financial',      icon: '💰', label: 'Revenue' },
  { id: 'referrals',      icon: '🔗', label: 'Referrals' },
  { id: 'callbacks',      icon: '📲', label: 'Callbacks' },
];

export default function MobileNav({ currentView, onNavigate, isAdmin, isDeveloper }) {
  const [moreOpen, setMoreOpen] = useState(false);

  const navigate = (id) => {
    setMoreOpen(false);
    onNavigate(id);
  };

  const homeTab = isAdmin || isDeveloper ? 'ops-console' : 'client-workspace';
  const extraItems = isAdmin || isDeveloper ? [...MORE_ADMIN, ...MORE_ITEMS] : MORE_ITEMS;

  return (
    <>
      {/* More sheet overlay */}
      {moreOpen && (
        <div className="mn-sheet-overlay" onClick={() => setMoreOpen(false)}>
          <div className="mn-sheet" onClick={e => e.stopPropagation()}>
            <div className="mn-sheet__handle" />
            <div className="mn-sheet__grid">
              {extraItems.map(item => (
                <button
                  key={item.id}
                  className={`mn-sheet__item${currentView === item.id ? ' mn-sheet__item--active' : ''}`}
                  onClick={() => navigate(item.id)}
                >
                  <span className="mn-sheet__icon">{item.icon}</span>
                  <span className="mn-sheet__label">{item.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom tab bar */}
      <nav className="mn-bar">
        {PRIMARY_TABS.map(tab => {
          const id = tab.adminId && (isAdmin || isDeveloper) ? tab.adminId : tab.id;
          const isMore = tab.id === '__more__';
          const active = isMore ? moreOpen : currentView === id;
          return (
            <button
              key={tab.id}
              className={`mn-tab${active ? ' mn-tab--active' : ''}`}
              onClick={() => isMore ? setMoreOpen(v => !v) : navigate(id)}
            >
              <span className="mn-tab__icon">{tab.icon}</span>
              <span className="mn-tab__label">{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
}
